import './dashboard-widgets'
import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const AssetLayout = lazy(() => import('./components/AssetLayout'))
const List = lazy(() => import('./components/List'))
const Detail = lazy(() => import('./components/Detail'))
const Create = lazy(() => import('./components/Create'))

const AssetModule: RouteObject = {
    path: 'assets',
    element: <AssetLayout />,
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <Create />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
        {
            path: ':id/edit',
            element: <Create />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AssetModule
